<template>
  <v-card class="pa-2 mt-3 mx-0">
    <v-data-table
        class="ma-4"
        :headers="headers_aff"
        :items="affectedUnits"
        :options.sync="optionsTable"
        :server-items-length="pageSize"
        :hide-default-footer="affectedUnits.length < 10"
        :loading="$store.state.affectations.isLoading"
        :footer-props="footerProps"
        density= 'compact'
        @click:row="selectUnit"
        >
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@5"></v-skeleton-loader>
        </template>
        <template v-slot:item.kind="{ item }">
          {{$filters.capitalize($filters.affectationKindFilter( item.kind ) ) }}
        </template>
        <template v-slot:item.date="{ item }">
          {{$filters.formatDate( item.date ) }}</template
        >
    </v-data-table>
  </v-card>
</template>

<script>
  import filters from "@/mixins/filters";
  import utils from "@/mixins/utils";
  import { isNone } from "@/functions";
  export default {
    mixins: [filters, utils],
    props: {
      stock_part_id: { type: Number, required: false },
      producer_id: { type: Number, required: false },
      stockage_id: { type: Number, required: false },
    },
    methods: {
      selectUnit(click, row) {
        this.$emit('unitSelected', row.item)
      },
      getAffectedUnits(stock_part_id, producer_id, stockage_id) {
        if (this.$store.state.affectations.isLoading) return
        let options = this.genPaginationPayload(this.optionsTable);
        let action   = '';
        let payload  = { options };

        if (stock_part_id) {
          action  = 'affectations/getOthers';
          payload.stock_part_id = stock_part_id;
        } else if (producer_id) {
          action  = 'affectations/getInProduction';
          payload.producer_id = producer_id;
          payload.no_qr_code = true;
        } else if (stockage_id) {
          action  = 'affectations/getInStock';
          payload.stockage_id = stockage_id;
          payload.no_qr_code = true;
        } else {
          return Promise.resolve();
        }
        return this.$store.dispatch(action, payload)
          .then(items => {
            this.affectedUnits = items.results;
            this.pageSize      = items.size;
          });
      },
      loadList() {
        if (!isNone(this.stock_part_id)) {
          this.getAffectedUnits(this.stock_part_id, null, null);
        }
        if (!isNone(this.producer_id)) {
          this.getAffectedUnits(null, this.producer_id, null);
        }
        if (!isNone(this.stockage_id)) {
          this.getAffectedUnits(null, null, this.stockage_id);
        }
      },
    },
    mounted(){
      this.loadList();
    },

    watch: {

      stock_part_id: 'loadList',
      producer_id: 'loadList',
      stockage_id: 'loadList',
      optionsTable: {
        handler() {
          this.loadList()
        },
        deep: true,
      },
    },
    data() {
      return {
        moduleName: "units",
        affectedUnits: [],
        optionsTable: {},
        pageSize: undefined,
        headers_aff: [
          {
            title: this.$t("affectations.status.label"),
            key: "kind",
            sortable: true,
          },
          {
            title: this.$t("generic.date"),
            key: "date",
            sortable: true,
          },
          {
            title: this.$t("stock_parts.label"),
            key: "unit.stock_part.name",
            sortable: true,
          },
          {
            title: this.$t("units.serial", 1),
            key: "unit.serial",
            sortable: true,
          },
          {
            title: this.$t("units.code", 1),
            key: "unit.qr_code",
            sortable: true,
          },
          // // // TODO: add on serializer
          // {
          //   title: this.$t("generic.created_at", 1),
          //   key: "unit.serial",
          //   sortable: false,
          // },
        ],
        footerProps: {
          "items-per-page-options": [10, 20, 50, -1],
          "items-per-page-text": this.$t("rows_per_page"),
        },
      };
    },
  };
</script>
